import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import axios from '../../axios';

import Button, { EButtonColor } from '../../components/UI/Button/Button';
import Container from '../../components/UI/Container/Container';
import Input, { EInputType } from '../../components/UI/Input/Input';
import ChangePasswordDialog from '../../components/Auth/ChangePasswordDialog/ChangePasswordDialog';
import ModalContext, { defaultModal, EModalSize } from '../../components/UI/Modal/ModalContext';
import { useAuthUser } from '../../hooks/useAuthUser';
import i18n, { ELanguage } from '../../i18n';
import * as actions from '../../store/actions';
import { ETranslation } from '../../translations/translation-keys';
import classes from './Settings.module.scss';

interface IProps extends RouteComponentProps { }

export enum ESettings {
  preferredLanguage = "preferredLanguage",
}

const languageOptions =  [
  {
    labelTranslation: ETranslation.LANGUAGE_ENGLISH,
    value: ELanguage.EN,
  },
  {
    labelTranslation: ETranslation.LANGUAGE_FINNISH,
    value: ELanguage.FI,
  },
];

const Settings: React.FC<IProps> = ({ history }) => {

  const { setModal } = useContext(ModalContext);
  const dispatch = useDispatch();
  const authUser = useAuthUser();
  const { t } = useTranslation();

  const [language, setLanguage] = useState(ELanguage.FI);


  const userLanguage = authUser?.preferredLanguage;

  useEffect(() => {
    if (userLanguage) {
      setLanguage(userLanguage);
    }
  }, [userLanguage]);

  const openChangePasswordModal = () => setModal({
    isOpen: true,
    title: t(ETranslation.CHANGE_PASSWORD),
    size: EModalSize.SMALL,
    content: <ChangePasswordDialog onCancel={() => setModal(defaultModal)} />,
  });

  const submitHandler = async (value: ELanguage) => {
    const preferredLanguage = value;
    i18n.changeLanguage(preferredLanguage);
    dispatch(actions.changeUserLanguage(preferredLanguage));
    setLanguage(value);
  };

  const clearMemcache = async () => {
    try {
      await axios.get("/tools/tasks?action=clearallcache");
      setModal({
        isOpen: true,
        title: "Onnistui",
        size: EModalSize.SMALL,
        content: <p>Memcache on tyhjennetty onnistuneesti.</p>,
      });
    } catch (e) {
      console.error(e);
      setModal({
        isOpen: true,
        title: "Virhe",
        size: EModalSize.SMALL,
        content: <p>Virhe memcachen puhdistuksessa.</p>,
      });
    }
  };

  return (
    <Container>
      <h2>{t(ETranslation.TITLE_SETTINGS)}</h2>
      <div>
        <Button onClick={openChangePasswordModal}>{t(ETranslation.CHANGE_PASSWORD)}</Button>
      </div>
      <div style={{ marginTop: '1rem' }}>
        {authUser?.isPrimary && (
          <Button onClick={clearMemcache} color={EButtonColor.DANGER}>Tyhjennä kaikki memcache objectit</Button>
        )}
      </div>
      <h2 style={{ marginTop: '2rem' }}>{t(ETranslation.LANGUAGE_TITLE)}</h2>
      <div className={classes.RadioContainer}>
      <Input
        value={language}
        type={EInputType.radio}
        onChange={(value) => submitHandler(value as ELanguage)}
        inputName="language"
        options={languageOptions}
      />
      </div>
    </Container>
  );
}

export default Settings;
